import React from 'react';
import { GlassCard } from '../shared/GlassCard';
import { GradientText } from '../shared/GradientText';

const steps = [
  {
    number: '1',
    icon: '/images/icon-connect-wallet.png',
    title: 'Connect Wallet',
    description: 'Link your BSC-compatible wallet in seconds. No registration required.',
  },
  {
    number: '2',
    icon: '/images/icon-pick-numbers.png',
    title: 'Pick Numbers',
    description: 'Choose your lucky numbers or use our Quick Pick random generator.',
  },
  {
    number: '3',
    icon: '/images/icon-win-instantly.png',
    title: 'Win Instantly',
    description: 'Real-time USDT payouts directly to your wallet. No waiting.',
  },
];

function HowItWorksSection() {
  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-gradient-to-b from-dark-secondary to-dark" />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/background-howitworks.jpg)',
          opacity: 0.2,
        }}
      />
      <div className="absolute inset-0 particle-bg opacity-40" />

      <div className="container-premium relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            <GradientText variant="hash" className="text-3xl sm:text-4xl lg:text-5xl font-bold">How It</GradientText>{' '}
            <GradientText variant="medora" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Works</GradientText>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Three simple steps to start winning on HashMedora
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <GlassCard key={index} variant="blue" className="p-8 text-center relative">
              {/* Step number */}
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-gradient-to-r from-hash-gold to-hash-gold-dark flex items-center justify-center text-white text-sm font-bold">
                {step.number}
              </div>

              <div className="mb-5 mt-2">
                <img src={step.icon} alt={step.title} className="w-16 h-16 mx-auto object-contain" />
              </div>

              <h3 className="text-xl font-bold text-white mb-3 text-shadow-dark">{step.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
